/**
 * Список вакансий
 *
 * @param {Object} params
 * @param {String} params.dataUrl URL для получения результатов
 */
$.fn.vacanciesList = function(params) {
    var $self = $(this);
    var dataUrl = params.dataUrl;

    var currentPage = 0;
    var dataLoading = false;
    var allLoaded = false;

    /**
     * Загрузить данные списка
     * @param {Number} page
     */
    var loadData = function (page) {
        if (dataLoading || allLoaded) {
            return false;
        }
        dataLoading = true;

        var data = [];
        data.push({
            name: 'page',
            value: page
        });

        $.ajax({
            url: dataUrl,
            method: 'get',
            dataType: 'json',
            data: data,
            success: function (result) {
                currentPage = result.page;

                $self.append(result.html);

                allLoaded = currentPage >= result.maxPage;

                dataLoading = false;
            },
            error: function () {
                dataLoading = false;
                console.error('Ошибка загрузки списка');
            }
        });
    };

    /**
     * Загрузка по скролу
     */
    $(window).scroll(function() {
        var windowHeight = $(window).height();
        var screenBottomPosition = $(window).scrollTop() + windowHeight;
        var listEndPosition = $self.position().top + $self.outerHeight();

        if(screenBottomPosition >= listEndPosition) {
            loadData(currentPage + 1);
        }
    });

    return this;
};


if ($('#vacancies-list').length === 1) {
    $('#vacancies-list').vacanciesList({
        dataUrl: $('#vacancies-list').data('data-url'),
    });
}
